import {
    IonPage, IonContent, IonInput, IonTitle, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import Datetime from "react-datetime";
import 'react-datetime/css/react-datetime.css';
import {addressInit} from "../../../../utils/address";
import {isPhoneNumber} from "../../../../utils/commonFunction";
import {submitStolen} from "./Service";
import cookieUtil from "../../../../utils/cookieUtil";
import {captchaKeFuAppId, captchaUrl} from "../../../../utils/common";
import Script from "react-load-script";
import moment from "moment/moment";
import 'moment/locale/zh-cn';

moment.locale('zh-cn');


class AccountTheft extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            phoneTip: 0,
            code: '',
            codeTip: null,
            agreementTip: true,
            scriptLoaded: false,
            showTipModal: false,
            getCodeMsg: "获取验证码",
            showNoticeTip: false,
            djs: '',
            abnormalTime: '',
            lastLoginTime: '',
            step: 1,
            content: '',
            account: '',
            token: null,
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)

    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }

    checkPhone = () => {
        const {phone} = this.state;
        let phoneTip = 0;
        if (!this.regPhone.test(phone)) {
            phoneTip = 1;
        }
        console.log('phoneTip====' + phoneTip)
        this.setState({
            phoneTip: phoneTip,
        })

    };

    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
        }

        if (cookieUtil.has("userInfo")) {
            let userInfoJson = JSON.parse(cookieUtil.get("userInfo"))
            //console.log(userInfoJson);
            this.setState({account: userInfoJson.userGameId})
        }
        addressInit('seachprov', 'seachcity', 'seachdistrict');
    }


    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }

        this.setState({
            code: e,
            codeTip: codeTip
        })
    }

    showNotice = () => {
        const {showNoticeTip} = this.state;
        this.setState({
            showNoticeTip: !showNoticeTip
        })
    }

    setAbnormalTime = (moment) => {
        if (moment._isAMomentObject) {
            const selectedDate = moment.format('YYYY-MM-DD');
            const selectedTime = moment.format('HH:mm:ss');
            const selectedDateTime = selectedDate + ' ' + selectedTime;
            this.setState({abnormalTime: selectedDateTime})
        } else if (moment.length > 0) {
            this.setState({abnormalTime: moment})
        }
    }

    setLastLoginTime = (moment) => {
        if (moment._isAMomentObject) {
            const selectedDate = moment.format('YYYY-MM-DD');
            const selectedTime = moment.format('HH:mm:ss');
            const selectedDateTime = selectedDate + ' ' + selectedTime;
            this.setState({lastLoginTime: selectedDateTime})
        } else if (moment.length > 0) {
            this.setState({lastLoginTime: moment})
        }
    }

    validateTimeFormat = () => {
        const {abnormalTime, lastLoginTime} = this.state;
        if (abnormalTime && !this.validateDateTimeFormat(abnormalTime)) {
            this.setState({isShowTip: true, showTipMsg: '出现异常的时间格式不正确，请重新选择'})
            return;
        }
        if (lastLoginTime && !this.validateDateTimeFormat(lastLoginTime)) {
            this.setState({isShowTip: true, showTipMsg: '最后登录的时间格式不正确，请重新选择'})
            return;
        }
    }

    validateDateTimeFormat = (dateTimeString) => {
        const dateTimeFormat = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/;
        return dateTimeFormat.test(dateTimeString);
    }


    nextStep = () => {
        const {step, initGold, residueGold, stolenGold, account, lastLoginTime, abnormalTime, phone} = this.state;
        if (step === 1) {

            if (account === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入正确的账号/游戏ID'})
                return;
            }

            if (stolenGold === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入账号被偷金币！'})
                return;
            }
            if (isNaN(stolenGold)) {
                this.setState({isShowTip: true, showTipMsg: '账号被偷金币请输入数字！'})
                return;
            }


            if (!isPhoneNumber(phone)) {
                this.setState({isShowTip: true, showTipMsg: '请输入正确的手机号码！'})
                return;
            }
            if (abnormalTime === '' || !this.validateDateTimeFormat(abnormalTime)) {
                this.setState({isShowTip: true, showTipMsg: '请输入账号被盗时间！'})
                return;
            }

            this.setState({step: 2, showNoticeTip: false});
        } else if (step === 2) {
            //获取loginArea
            const seachprovValue = document.getElementById('seachprov').value;
            const seachcityValue = document.getElementById('seachcity').value;
            const seachdistrictValue = document.getElementById('seachdistrict').value;
            const oftenLoginArea = seachprovValue + seachcityValue + seachdistrictValue;

            if (initGold === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入账号初始金币！'})
                return;
            }
            if (isNaN(initGold)) {
                this.setState({isShowTip: true, showTipMsg: '账号初始金币请输入数字！'})
                return;
            }

            if (residueGold === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入账号目前金币！'})
                return;
            }
            if (isNaN(residueGold)) {
                this.setState({isShowTip: true, showTipMsg: '账号目前金币请输入数字！'})
                return;
            }

            if (oftenLoginArea === '' || oftenLoginArea === 'null') {
                this.setState({isShowTip: true, showTipMsg: '请选择常登录的地区！'})
                return;
            }

            this.setState({
                step: 3,
                showNoticeTip: false
            });
        }

    }


    submitMsg = () => {
        const {
            account,
            phone,
            initGold,
            residueGold,
            stolenGold,
            abnormalTime,
            lastLoginTime,
            content,
        } = this.state;

        //获取 登录系统
        const loginEnvCheckBoxs = document.getElementsByName('loginEnv');
        let loginEnvironment = '';
        for (let i = 0; i < loginEnvCheckBoxs.length; i++) {
            if (loginEnvCheckBoxs[i].checked) {
                if (loginEnvironment.length === 0) {
                    loginEnvironment = loginEnvCheckBoxs[i].value;
                    continue;
                }
                loginEnvironment = loginEnvironment + "," + loginEnvCheckBoxs[i].value;
            }
        }


        //获取 登录设备
        const loginDeviceCheckBoxs = document.getElementsByName('loginDevice');
        let loginDevice = '';
        for (let i = 0; i < loginDeviceCheckBoxs.length; i++) {
            if (loginDeviceCheckBoxs[i].checked) {
                if (loginDevice.length === 0) {
                    loginDevice = loginDeviceCheckBoxs[i].value;
                    continue;
                }
                loginDevice = loginDevice + "," + loginDeviceCheckBoxs[i].value;
            }
        }

        //获取 是否发送信息
        const loginOsRadios = document.getElementsByName('msg');
        let isReceiveYzm = 0;
        for (let i = 0; i < loginOsRadios.length; i++) {
            if (loginOsRadios[i].checked) {
                isReceiveYzm = loginOsRadios[i].value
            }
        }


        //获取 是否告诉他人密码
        const passwordRadios = document.getElementsByName('password');
        let isTellOtherPwd = 0;
        for (let i = 0; i < passwordRadios.length; i++) {
            isTellOtherPwd = passwordRadios[i].value;
        }

        //获取loginArea
        const seachprovValue = document.getElementById('seachprov').value;
        const seachcityValue = document.getElementById('seachcity').value;
        const seachdistrictValue = document.getElementById('seachdistrict').value;
        const oftenLoginArea = seachprovValue + seachcityValue + seachdistrictValue;

        if (account === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入正确的账号/游戏ID'})
            return;
        }

        if (initGold === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入账号初始金币！'})
            return;
        }
        if (isNaN(initGold)) {
            this.setState({isShowTip: true, showTipMsg: '账号初始金币请输入数字！'})
            return;
        }

        if (residueGold === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入账号目前金币！'})
            return;
        }
        if (isNaN(residueGold)) {
            this.setState({isShowTip: true, showTipMsg: '账号目前金币请输入数字！'})
            return;
        }

        if (stolenGold === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入账号被偷金币！'})
            return;
        }
        if (isNaN(stolenGold)) {
            this.setState({isShowTip: true, showTipMsg: '账号被偷金币请输入数字！'})
            return;
        }

        if (abnormalTime == '' || !this.validateDateTimeFormat(abnormalTime)) {
            this.setState({isShowTip: true, showTipMsg: '请输入账号被偷时间！'})
            return;
        }

        if (oftenLoginArea === '' || oftenLoginArea === 'null') {
            this.setState({isShowTip: true, showTipMsg: '请选择常登录的地区！'})
            return;
        }

        if (!isPhoneNumber(phone)) {
            this.setState({isShowTip: true, showTipMsg: '请输入正确的手机号码！'})
            return;
        }

        if (content === '' || content.length < 10) {
            this.setState({isShowTip: true, showTipMsg: '问题（如操作过程、发生异常的情况等），至少输入10个汉字'})
            return;
        }

        const _that = this;
        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {
            if (res.ret === 0) {
                const params = {
                    'initGold': initGold + '',
                    'residueGold': residueGold + '',
                    'stolenGold': stolenGold + '',
                    'stolenTime': abnormalTime,
                    'lastLoginTime': lastLoginTime,
                    'oftenLoginArea': oftenLoginArea,
                    'loginEnvironment': loginEnvironment,
                    'loginDevice': loginDevice,
                    'isReceiveYzm': isReceiveYzm,
                    'isTellOtherPwd': isTellOtherPwd,
                    'phone': phone,
                    'content': content,
                    'accounts': account,
                    'ticket': res.ticket,
                    'randStr': res.randstr,
                }
                submitStolen(params).then(ret => {
                    if (ret.code === '10000') {
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: "提交成功，请耐心等待我们处理。"
                        })
                    } else {
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: ret.msg
                        })
                    }
                    captcha1.destroy();
                }).catch(err => {
                    console.log(err);
                    captcha1.destroy();
                });
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});
        captcha1.show(); // 显示验证码
    }


    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }

    previousStep = () => {
        const {step} = this.state;
        this.setState({
            step: step - 1,
        })
    }

    render() {

        const {
            abnormalTime,
            step,
            lastLoginTime,
            showNoticeTip,
            seachprov,
            seachcity,
            seachdistrict,
            phone,
            account,
            stolenGold,
            initGold,
            residueGold,
            content
        } = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont bggray">
                        <div className="phone_top pr border-bottom-e6">
                            <a onClick={() => this.previousStep()}
                               className={step > 1 ? "previous_step" : 'dn'}>上一步</a>
                            <div className="top_title">账号被盗</div>

                        </div>
                        <Script
                            url={captchaUrl()}
                            onError={this.handleScriptError}
                            onLoad={this.handleScriptLoad}
                        />
                        <div className={step === 1 ? "cont_kf" : "dn"}>
                            <div className="point_tex">
                                <p>账号被盗反馈期限为24小时，如需紧急冻结请及时联系在线客服处理。</p>
                            </div>
                            <div className="phone_identity clearfix">
                                <span className="w280">* 游戏账号或ID</span>
                                <input type="text" className="input-tex4" value={account}
                                       onChange={e => {
                                           this.setState({account: e.target.value})
                                       }}
                                       placeholder="第三方账号请填写游戏ID"/>
                            </div>
                            <div className="phone_identity clearfix">
                                <span className="w280">* 账号被盗金币</span>
                                <input type="text" className="input-tex4" value={stolenGold}
                                       onChange={e => {
                                           this.setState({stolenGold: e.target.value})
                                       }}
                                       placeholder="填写实际被盗金币 "/>
                            </div>
                            <div className="phone_identity clearfix">
                                <span className="w280">* 账号被盗时间</span>
                                <Datetime
                                    className={"dateForm-control"}
                                    input={true}
                                    dateFormat="YYYY-MM-DD"
                                    timeFormat="HH:mm:ss"
                                    value={abnormalTime}
                                    onChange={this.setAbnormalTime}
                                    onClose={this.validateTimeFormat}
                                />
                                {/*<input type="datetime-local" className="datetime"/>*/}
                            </div>
                            <div className="phone_identity clearfix">
                                <span className="w280">* 联系手机号码</span>
                                <input type="text" className="input-tex4" value={phone}
                                       onChange={e => {
                                           this.setState({phone: e.target.value})
                                       }}
                                       placeholder="填写手机号码"/>
                            </div>
                            <a className="btn_kf mt100" onClick={this.nextStep}>下一步</a>
                            <div className="cont_tex">
                                <div className="cont_tex_title" onClick={this.showNotice}>账号安全</div>
                                <p className={showNoticeTip ? "hidden_tex" : "dn"}>
                                    账号安全需要玩家自身进行防范，提高安全意识，建议您勿将账号信息共享他人，保持常修改账号密码的良好习惯。</p>
                            </div>
                        </div>
                        <div className={step === 2 ? "cont_kf" : "dn"}>
                            <div className="phone_identity clearfix">
                                <span className="w280">* 账号初始金币</span>
                                <input type="text" className="input-tex4" value={initGold}
                                       onChange={e => {
                                           this.setState({initGold: e.target.value})
                                       }}
                                       placeholder="请填写账号初始金币"/>
                            </div>
                            <div className="phone_identity clearfix">
                                <span className="w280">* 账号当前金币</span>
                                <input type="text" className="input-tex4" value={residueGold}
                                       onChange={e => {
                                           this.setState({residueGold: e.target.value})
                                       }}
                                       placeholder="请填写账号目前金币"/>
                            </div>

                            <div className="phone_identity clearfix">
                                <span className="w246">* 常登录的地区</span>
                                <div className="login_area">
                                    <center>
                                        <select id="seachprov" className="select_input1 w120 mr10" name="seachprov"
                                                value={seachprov}></select>
                                        <select id="seachcity" className="select_input1 w120 mr10" name="homecity"
                                                value={seachcity}></select>
                                        <select id="seachdistrict" className="select_input1 w120" name="homecity"
                                                value={seachdistrict}></select>
                                        <div className="clear"></div>
                                    </center>
                                </div>
                            </div>

                            <div className="phone_identity clearfix">
                                <span className="w280">最后登录时间</span>
                                <Datetime
                                    className={"dateForm-control"}
                                    input={true}
                                    dateFormat="YYYY-MM-DD"
                                    timeFormat="HH:mm:ss"
                                    value={lastLoginTime}
                                    onChange={this.setLastLoginTime}
                                    onClose={this.validateTimeFormat}
                                />
                            </div>

                            <a className="btn_kf mt100" onClick={() => this.nextStep()}>下一步</a>
                            <div className="cont_tex">
                                <div className="cont_tex_title" onClick={this.showNotice}>被盗须知</div>
                                <p className={showNoticeTip ? "hidden_tex" : "dn"}>
                                    1、请如实填写，如信息有误将无法处理。<br/>
                                    2、因账号信息主动泄露他人等导致被盗不予受理。<br/>
                                    3、因游戏违规等导致账号被盗不予处理。</p>
                            </div>
                        </div>
                        <div className={step === 3 ? "cont_kf" : "dn"}>
                            <div className="phone_upload clearfix pr">
                                <span>是否收到短信</span>
                                <div className="radio_cont1 clearfix">
                                    <label className="w200_kf"><input type="radio" value="1" name="msg"
                                                                   defaultChecked='true' className="radio"/>是</label>
                                    <label className="w200_kf"><input type="radio" value="0" name="msg"
                                                                   className="radio"/>否</label>
                                </div>
                            </div>
                            <div className="phone_upload clearfix pr">
                                <span>密码是否泄露</span>
                                <div className="radio_cont2 clearfix">
                                    <label className="w200_kf"><input type="radio" value="1" name="password"
                                                                   defaultChecked='true' className="radio"/>是</label>
                                    <label className="w200_kf"><input type="radio" value="0" name="password"
                                                                   className="radio"/>否</label>
                                </div>
                            </div>
                            <div className="phone_upload clearfix pr">
                                <span>账号登录环境</span>
                                <div className="radio_cont2 clearfix">
                                    <label className="w85p"><input type="radio" value="网吧" name="loginEnv"/>网吧
                                    </label>
                                    <label className="w85p"><input type="radio" value="宾馆"
                                                                   name="loginEnv"/>宾馆</label>
                                    <label className="w85p"><input type="radio" value="家里"
                                                                   name="loginEnv"/>家里</label>
                                </div>
                            </div>
                            <div className="phone_upload clearfix pr">
                                <span>账号登录设备</span>
                                <div className="radio_cont2 clearfix">
                                    <label className="w85p"><input type="radio" value="电脑" name="loginDevice"/>电脑
                                    </label>
                                    <label className="w85p"><input type="radio" value="手机" name="loginDevice"/>手机</label>
                                    <label className="w85p"><input type="radio" value="其他" name="loginDevice"/>其他</label>
                                </div>
                            </div>
                            <div className="phone_instructions">
                                <span>* 账号异常说明</span>
                                <textarea name="textarea" id="textarea"
                                          value={content}
                                          onChange={e => {
                                              this.setState({content: e.target.value})
                                          }}
                                          className="textarea"
                                          placeholder={"提示：请尽可能描述您所发现的问题（如操作过程，发生异常的情况等，至少输入10个汉字） "}></textarea>
                            </div>
                            <a className="btn_kf mt100" onClick={this.submitMsg}>提交</a>
                            <div className="cont_tex">
                                <div className="cont_tex_title" onClick={this.showNotice}>处理流程</div>
                                <p className={showNoticeTip ? "hidden_tex" : "dn"}>
                                    1、请您理解，为保护账号安全，我们可能会将您的账号给予临时冻结保护。<br/>
                                    2、我们将在3个工作日（节假日顺延）内通过游戏邮件或短信告知您核实结果。<br/>
                                    3、问题处理完毕后请您及时修改账号密码，如因原密码再次发生被盗，我们将不予再次受理。</p>
                            </div>
                        </div>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(AccountTheft);
